import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  overlay: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: spacing(4),
    justifyContent: "center",
    padding: spacing(2),
    variants: {
      visible: {
        false: {
          display: "none",
        },
      },
    },
  },
}));

export default stylesheet;
